import RatingsDisplaySdk from '@wix/thunderbolt-elements/src/components/RatingsDisplay/corvid/RatingsDisplay.corvid';


const RatingsDisplay = {
  sdk: RatingsDisplaySdk
};


export const components = {
  ['RatingsDisplay']: RatingsDisplay
};

